import { webAPI } from '../../../axiosInstance';


const getAllCategories = async () => {
  const response = await webAPI.get('/categories');
  return response.data;
};


const addCategory = async (data: any) => {
  console.log('data2333', data)
  const response = await webAPI.post('/categories', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

const deleteCategory = async (data: any) => {
  const response = await webAPI.delete(`/categories/delete/${data}`);
  return response.data;
};

export { getAllCategories, addCategory, deleteCategory };
